/// <reference path="./types/index.d.ts" />



//////////////////
// WEBPACK FOOTER
// ./node_modules/miniprogram-api-typings/index.d.ts
// module id = 205
// module chunks = 0 1